import React from 'react';
import { Plus, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { Character } from '../types/character';
import { Universe, universeCharacteristics } from '../types/template';

interface Props {
  onCharacterCreate: (character: Character) => void;
  isLoading?: boolean;
  disabled?: boolean;
  onLimitReached?: () => void;
}

export function NewCharacterButton({ onCharacterCreate, isLoading, disabled, onLimitReached }: Props) {
  const handleClick = () => {
    if (disabled) {
      onLimitReached?.();
      return;
    }

    const universe: Universe = 'medieval';
    const characteristics = universeCharacteristics[universe];

    const newCharacter: Character = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      name: 'Nouveau Personnage',
      universe,
      themeColor: 'purple',
      profileImage: '',
      backgroundImage: '',
      sections: [
        { id: '1', title: 'Description Physique', content: '' },
        { id: '2', title: 'Personnalité', content: '' },
        ...characteristics.map((title, index) => ({
          id: `${Date.now()}-${index + 3}`,
          title,
          content: ''
        }))
      ],
      customSections: [],
      illustrations: [],
      lastModified: Date.now()
    };

    onCharacterCreate(newCharacter);
  };

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={handleClick}
      disabled={isLoading}
      className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors
        ${disabled
          ? 'bg-yellow-400 text-yellow-900 hover:bg-yellow-500 cursor-pointer'
          : 'bg-white text-purple-600 hover:bg-gray-100'}
        ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {disabled ? <Lock className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
      {isLoading ? 'Création...' : disabled ? 'Limite atteinte' : 'Nouveau personnage'}
    </motion.button>
  );
}
